<template>
  <div class="apply">
    <div class="box-card">
      <div class="head">
        <span class="applyTitle"> {{ $t("special.specialApply") }}</span>

        <span class="applyEnd">{{
          $t("common.tishi", { time: "2023年9月20日" })
        }}</span>
      </div>

      <div class="serveMessage">
        <!-- 展商信息 -->
        <div class="exhibitorsMsg">
          <p>{{ $t("exhiInformat.exhibitor") }}</p>
          <div class="content">
            <div class="row">
              <div class="left">
                <span class="name">{{ $t("special.exhiName") }}：</span
                ><span>{{ exhibitorsMsg.companyNameC }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("exhiInformat.address") }}</span>
                <span>{{ exhibitorsMsg.addressC }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name"
                  >{{ $t("exhiInformat.positionNumber") }}：</span
                ><span>{{ boothVO1[0].boothNum }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("exhiInformat.boothType") }}：</span>
                <span>{{ boothVO1[0].bootTypeName }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">{{ $t("exhiInformat.pavilion") }}：</span>
                <span>{{ boothVO1[0].boothName }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("exhiInformat.boothArea") }}：</span>
                <span>{{ boothVO1[0].boothArea }}m²</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">{{ $t("exhiInformat.type") }}：</span>
                <span>{{ exhibitorsMsg.enteProperty }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("special.linkman") }}：</span>
                <span>{{ exhibitorsMsg.userName }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">{{ $t("special.iphone") }}：</span
                ><span>{{ exhibitorsMsg.userTel }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("special.telephone") }}：</span
                ><span>{{ exhibitorsMsg.telephone }}</span>
              </div>
            </div>

            <div class="row">
              <div class="left">
                <span class="name">E-mail：</span
                ><span>{{ exhibitorsMsg.email }}</span>
              </div>
              <div class="right">
                <span class="name">{{ $t("exhiInformat.boothType") }}：</span
                ><span class="my-el-select">
                  <el-select
                    v-model="boothVO1[0].column14"
                    :placeholder="$t('special.placeholder')"
                    style="width: 260px"
                    :disabled="flag == '2' ? true : false"
                  >
                    <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option> </el-select
                ></span>
              </div>
            </div>
          </div>
        </div>
        <!-- 搭建商信息 -->
        <div class="exhibitorsMsg">
          <p>{{ $t("special.exhibProduc") }}</p>
          <div class="daJian">
            <el-form
              :model="hzExhibitProducer"
              ref="hzExhibitProducer"
              label-width="160px"
              class="demo-ruleForm"
              :rules="rules"
              :disabled="flag == '2' ? true : false"
            >
              <el-row>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('special.exProName') + '：'"
                    prop="exhProName"
                  >
                    <el-input
                      type="age"
                      v-model="hzExhibitProducer.exhProName"
                      autocomplete="off"
                      :placeholder="$t('common.placeholder')"
                      maxlength="50"
                      show-word-limit
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    :label="$t('special.exProAddress') + '：'"
                    prop="comAddress"
                  >
                    <el-input
                      type="age"
                      v-model="hzExhibitProducer.comAddress"
                      autocomplete="off"
                      :placeholder="$t('common.placeholder')"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('special.exprolinman') + '：'"
                    prop="linkman"
                  >
                    <el-input
                      type="age"
                      v-model="hzExhibitProducer.linkman"
                      autocomplete="off"
                      :placeholder="$t('common.placeholder')"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    :label="$t('special.exproIphone') + '：'"
                    prop="cellphone"
                  >
                    <el-input
                      type="age"
                      v-model="hzExhibitProducer.cellphone"
                      autocomplete="off"
                      :placeholder="$t('common.placeholder')"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row>
                <el-col :span="11">
                  <el-form-item
                    :label="$t('special.exproTelephone') + '：'"
                    prop="telephone"
                  >
                    <el-input
                      type="age"
                      v-model="hzExhibitProducer.telephone"
                      autocomplete="off"
                      :placeholder="$t('common.placeholder')"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item
                    label="E-mail："
                    prop="email"
                    :placeholder="$t('common.placeholder')"
                  >
                    <el-input
                      type="age"
                      v-model="hzExhibitProducer.email"
                      autocomplete="off"
                      :placeholder="$t('common.placeholder')"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </div>

        <!--展台信息 -->
        <div class="exhibitorsMsg">
          <p>{{ $t("special.boothInfor") }}</p>
          <div class="daJian">
            <el-form
              :model="hzBoothInfo"
              label-width="215px"
              class="demo-ruleForm"
              :rules="rulesBooth"
              ref="boothInformation"
              :disabled="flag == '2' ? true : false"
            >
              <el-row>
                <el-col :span="13">
                  <el-form-item
                    :label="$t('special.boothHeight') + '：'"
                    prop="bootHight"
                  >
                    <el-input
                      v-model="hzBoothInfo.bootHight"
                      autocomplete="off"
                      :placeholder="$t('common.placeholder')"
                      class="input"
                    ></el-input>
                  </el-form-item>
                </el-col>

                <el-col :span="11">
                  <span class="layerNumber"
                    >{{ $t("special.boothtier") }}：</span
                  >
                  <span>
                    <el-radio v-model="hzBoothInfo.bootLayer" label="1">{{
                      $t("special.onetier")
                    }}</el-radio>
                    <el-radio v-model="hzBoothInfo.bootLayer" label="2">{{
                      $t("special.twitier")
                    }}</el-radio>
                  </span>
                </el-col>
              </el-row>

              <el-row>
                <el-col>
                  <el-form-item
                    :label="$t('special.boothPoint') + '：'"
                    prop="pointHoistNum"
                    class="zhanTai"
                  >
                    <el-input
                      v-model.number="hzBoothInfo.pointHoistNum"
                      autocomplete="off"
                      :placeholder="$t('common.placeholder')"
                      class="point"
                      style="width: 300px"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <!------------- 展台照明用电 ---------------------->
              <el-row>
                <el-col :span="13">
                  <el-form-item
                    :label="$t('special.boothIllum') + '：'"
                    prop="bootTemporaryElectro"
                  >
                    <!-- 循环体头部标题 -->
                    <div class="lighting">
                      <div class="number">{{ $t("special.number") }}</div>
                      <div class="serveItem">
                        {{ $t("special.serviceProject") }}
                      </div>
                      <div>{{ $t("special.quantity") }}</div>
                    </div>
                    <!-- 循环体内容 -->
                    <div
                      class="lighting box"
                      v-for="(item, index) in booth"
                      :key="index"
                    >
                      <div class="number boxItem">{{ item.number }}</div>
                      <div class="serveItem boxItem">{{ item.serveItem }}</div>
                      <div class="count aa">
                        <el-input-number
                          :min="0"
                          :precision="0"
                          :controls="false"
                          controls-position="right"
                          v-model="item.num"
                          :placeholder="$t('special.placeholderNum')"
                        ></el-input-number>
                      </div>
                      {{ $t("special.locate") }}
                    </div>

                    <!-- 展台用水 -->
                    <el-form-item
                      :label="$t('special.boothWater') + '：'"
                      class="water"
                    >
                      <div class="lighting">
                        <div class="number">{{ $t("special.number") }}</div>
                        <div class="serveItem">
                          {{ $t("special.serviceProject") }}
                        </div>
                        <div>{{ $t("special.quantity") }}</div>
                      </div>
                      <div
                        class="lighting box"
                        v-for="(item, index) in water"
                        :key="index"
                      >
                        <div class="number boxItem">{{ item.number }}</div>
                        <div class="serveItem boxItem">
                          {{ item.serveItem }}
                        </div>
                        <div class="count aa">
                          <el-input-number
                            :min="0"
                            :precision="0"
                            :controls="false"
                            controls-position="right"
                            v-model="item.num"
                            :placeholder="$t('special.placeholderNum')"
                          ></el-input-number>
                        </div>
                        {{ $t("special.locate") }}
                      </div>
                    </el-form-item>
                  </el-form-item>
                </el-col>

                <!------------- 展台动力用电 ---------------------->

                <el-col :span="11">
                  <el-form-item
                    :label="$t('special.boothPower') + '：'"
                    prop="bootPowerElectro"
                  >
                    <div class="lighting">
                      <div class="number">{{ $t("special.number") }}</div>
                      <div class="serveItem">
                        {{ $t("special.serviceProject") }}
                      </div>
                      <div>{{ $t("special.quantity") }}</div>
                    </div>
                    <div
                      class="lighting box"
                      v-for="(item, index) in boothPower"
                      :key="index"
                    >
                      <div class="number boxItem">{{ item.number }}</div>
                      <div class="serveItem boxItem">{{ item.serveItem }}</div>
                      <div class="count aa">
                        <el-input-number
                          :min="0"
                          :precision="0"
                          :controls="false"
                          controls-position="right"
                          v-model="item.num"
                          :placeholder="$t('special.placeholderNum')"
                        ></el-input-number>
                      </div>
                      {{ $t("special.locate") }}
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-----------------上传展台效果图------------------->
              <el-row>
                <el-col :span="24">
                  <el-form-item
                    :label="$t('special.uploadimg1') + '：'"
                    prop="bootImg"
                    style="margin-top: 17px"
                  >
                    <div class="imgBox">
                      <ul>
                        <li
                          v-for="(item, index) in productImgList"
                          :key="index"
                        >
                          <div
                            :style="{
                              background:
                                'url(' +
                                item.url +
                                ')#f1f1f1 no-repeat center /contain',
                            }"
                            class="upload-logo"
                          >
                            <img
                              alt="删除"
                              src="../../../static/icon_del.png"
                              @click="delImg1(index)"
                            />

                            <el-upload
                              :action="baseFileUrl"
                              ref="imgUpload"
                              :headers="getToken()"
                              :on-success="handSuccessExImg"
                              :limit="6"
                              :before-upload="beforeUpload"
                              :show-file-list="true"
                            >
                              <el-button
                                size="small"
                                style="margin: 0 auto"
                                @click="changeImgback(index)"
                                >{{ $t("common.selectfile") }}</el-button
                              >
                            </el-upload>
                          </div>
                        </li>
                      </ul>
                      <el-upload
                        :class="{ hide: flag == 2 }"
                        drag
                        ref="imgUpload"
                        class="upload-demo"
                        :action="baseFileUrl"
                        list-type="picture-card"
                        :on-remove="handleRemove"
                        :headers="getToken()"
                        :on-success="handSuccessExImg"
                        :limit="6"
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                      >
                        <div class="el-upload__text">
                          {{ $t("common.selectfile") }}
                        </div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
              <!---------------上传展台平面图------------------->

              <el-row>
                <el-col :span="24">
                  <el-form-item
                    :label="$t('special.uploadimg2') + '：'"
                    prop="column15"
                    style="margin-top: 17px"
                  >
                    <div class="imgBox">
                      <ul>
                        <li v-for="(item, index) in planImgArr" :key="index">
                          <div
                            :style="{
                              background:
                                'url(' +
                                item.url +
                                ')#f1f1f1 no-repeat center /contain',
                            }"
                            class="upload-logo"
                          >
                            <img
                              alt="删除"
                              src="../../../static/icon_del.png"
                              @click="delImg2(index)"
                            />

                            <el-upload
                              :action="baseFileUrl"
                              ref="imgUpload"
                              :headers="getToken()"
                              :on-success="handSuccessPlanImg"
                              :limit="6"
                              :before-upload="beforeUpload"
                              :show-file-list="false"
                            >
                              <el-button
                                size="small"
                                style="margin: 0 auto"
                                @click="changeImgback(index)"
                                >{{ $t("common.selectfile") }}</el-button
                              >
                            </el-upload>
                          </div>
                        </li>
                      </ul>
                      <el-upload
                        :class="{ hide: flag == 2 }"
                        drag
                        ref="imgUpload"
                        class="upload-demo"
                        :action="baseFileUrl"
                        list-type="picture-card"
                        :on-remove="handleRemove"
                        :headers="getToken()"
                        :on-success="handSuccessPlanImg"
                        :limit="6"
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                      >
                        <div class="el-upload__text">
                          {{ $t("common.selectfile") }}
                        </div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- --------------上传展台立面图------------------->

              <el-row>
                <el-col :span="24">
                  <el-form-item
                    :label="$t('special.uploadimg3') + '：'"
                    prop="column16"
                    style="margin-top: 17px"
                  >
                    <div class="imgBox">
                      <ul>
                        <li v-for="(item, index) in elevation" :key="index">
                          <div
                            :style="{
                              background:
                                'url(' +
                                item.url +
                                ')#f1f1f1 no-repeat center /contain',
                            }"
                            class="upload-logo"
                          >
                            <img
                              alt="删除"
                              src="../../../static/icon_del.png"
                              @click="delImg3(index)"
                            />

                            <el-upload
                              :action="baseFileUrl"
                              ref="imgUpload"
                              :headers="getToken()"
                              :on-success="handSuccessfacadeImg"
                              :limit="6"
                              :before-upload="beforeUpload"
                              :show-file-list="false"
                            >
                              <el-button
                                size="small"
                                style="margin: 0 auto"
                                @click="changeImgback(index)"
                                >{{ $t("common.selectfile") }}</el-button
                              >
                            </el-upload>
                          </div>
                        </li>
                      </ul>
                      <el-upload
                        :class="{ hide: flag == 2 }"
                        drag
                        ref="imgUpload"
                        class="upload-demo"
                        :action="baseFileUrl"
                        list-type="picture-card"
                        :on-remove="handleRemove"
                        :headers="getToken()"
                        :on-success="handSuccessfacadeImg"
                        :limit="6"
                        :before-upload="beforeUpload"
                        :show-file-list="false"
                      >
                        <div class="el-upload__text">
                          {{ $t("common.selectfile") }}
                        </div>
                      </el-upload>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>

              <!-- ------------------------------------------- -->
            </el-form>

            <div class="btn">
              <div class="why" v-show="flag == -1">
                {{ $t("active.noPass") }}
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content">{{ cause }}</div>
                  <router-link to="#">{{ $t("active.cause") }}</router-link>
                </el-tooltip>
              </div>
              <el-button
                type="primary"
                @click="submitForm('hzExhibitProducer')"
                v-if="flag != 2"
                >{{ $t("common.submit") }}</el-button
              >
              <el-button type="primary" disabled v-else>{{
                $t("active.inreview")
              }}</el-button>
            </div>
          </div>
        </div>
        <!-- 展商信息 -->
      </div>
    </div>
  </div>
</template>
<script>
import { getSpecalApply, saveSpecalApply } from "../../../../api/specalApply";
import { forMat, baseFileUrl } from "../../../../utils/common.js";

export default {
  data() {
    // var validateBootImg = (rule, value, callback) => {
    //   if (this.productImgList.length < 1) {
    //     callback(new Error('展台效果图不能为空,请重新选择!'));
    //   } else {
    //     callback();
    //   }
    // };

    // var validateColumn15 = (rule, value, callback) => {
    //   if (this.planImgArr.length < 1) {
    //     callback(new Error('展台平面图不能为空,请重新选择!'));
    //   } else {
    //     callback();
    //   }
    // };
    // var validateColumn16 = (rule, value, callback) => {
    //   if (this.elevation.length < 1) {
    //     callback(new Error('展台立面图不能为空,请重新选择!'));
    //   } else {
    //     callback();
    //   }
    // };

    return {
      radio: "1",
      cause: "", //申请失败的原因
      baseFileUrl: baseFileUrl(),
      baseUrl: forMat(),
      //整个表单提交
      sizeForm: {},
      // rulesBooth: {
      //   bootHight: [{ required: true, message: '请输入展台高度' }],
      //   bootImg: [{ validator: validateBootImg }, { trigger: 'change', message: '请选择展品效果图', required: true }],
      //   column15: [{ validator: validateColumn15 }, { trigger: 'change', message: '请选择展台平面图', required: true }],
      //   column16: [{ validator: validateColumn16 }, { trigger: 'change', message: '请选择展台立面图', required: true }],
      // },
      // rules: {
      //   exhProName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
      //   comAddress: [{ required: true, message: '搭建商地址不能为空', trigger: 'blur' }],
      //   linkman: [{ required: true, message: '联系人不能为空', trigger: 'blur' }],
      //   cellphone: [
      //     { required: true, message: '手号码不能为空', trigger: 'blur' },
      //     { min: 11, max: 15, message: '手机号最少为11位数' },
      //   ],
      //   email: [
      //     { required: true, message: 'E-mail邮箱不能为空', trigger: 'blur' },
      //     { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] },
      //   ],
      // },

      // inject:['reload'], //页面更新
      //展商信息
      exhibitorsMsg: {
        companyNameC: "", //公司名称
        addressC: "", // 公司地址
        enteProperty: "", //国内展商  企业类型
        userName: "", //联系人
        userTel: "", //联系电话
        telephone: "", //电话
        email: "",
      },
      //展馆信息集合
      boothVO1: [
        {
          id: "", //展馆id
          boothNum: "", //
          column14: "", //展馆类型
        },
      ],

      //展商信息中展台类型的下拉列表
      options: [
        {
          value: "岛型开口",
          label: "岛型开口",
        },
        {
          value: "半岛型开口",
          label: "半岛型开口",
        },
        {
          value: "单面开口",
          label: "单面开口",
        },
        {
          value: "双面开口",
          label: "双面开口",
        },
      ],

      //搭建商数组信息
      hzExhibitProducer: {
        exhProName: "", //搭建商名称
        comAddress: "", //搭建商地址
        linkman: "", // 联系人
        cellphone: "", // 手机
        telephone: "", //电话
        email: "", //email
      },
      //展台信息
      hzBoothInfo: {
        remarks: "", //展台用水
        bootHight: "", //展台高度
        bootLayer: "1", //展台层数
        bootPowerElectro: "", // 展台动力用电
        bootTemporaryElectro: "", //展台照明用电
        pointHoistNum: "", //展台吊点
        bootImg: "", //展位效果图
        column15: "", //展台平面图
        column16: "", //展台立面图
      },

      //展台照明用电
      booth: [
        {
          number: this.$t("common.num.one"),
          serveItem: this.$t("special.booth.project1"),
          num: "",
        },
        {
          number: this.$t("common.num.two"),
          serveItem: this.$t("special.booth.project2"),
          num: "",
        },
        {
          number: this.$t("common.num.three"),
          serveItem: this.$t("special.booth.project3"),
          num: "",
        },
        {
          number: this.$t("common.num.four"),
          serveItem: this.$t("special.booth.project4"),
          num: "",
        },
        {
          number: this.$t("common.num.five"),
          serveItem: this.$t("special.booth.project5"),
          num: "",
        },
        {
          number: this.$t("common.num.six"),
          serveItem: this.$t("special.booth.project6"),
          num: "",
        },
        {
          number: this.$t("common.num.seven"),
          serveItem: this.$t("special.booth.project7"),
          num: "",
        },
        {
          number: this.$t("common.num.eight"),
          serveItem: this.$t("special.booth.project8"),
          num: "",
        },
        {
          number: this.$t("common.num.nine"),
          serveItem: this.$t("special.booth.project9"),
          num: "",
        },
      ],

      //展台动力用电
      boothPower: [
        {
          number: this.$t("common.num.one"),
          serveItem: this.$t("special.powerProject.project1"),
          num: "",
        },
        {
          number: this.$t("common.num.two"),
          serveItem: this.$t("special.powerProject.project2"),
          num: "",
        },
        {
          number: this.$t("common.num.three"),
          serveItem: this.$t("special.powerProject.project3"),
          num: "",
        },
        {
          number: this.$t("common.num.four"),
          serveItem: this.$t("special.powerProject.project4"),
          num: "",
        },
        {
          number: this.$t("common.num.five"),
          serveItem: this.$t("special.powerProject.project5"),
          num: "",
        },
        {
          number: this.$t("common.num.six"),
          serveItem: this.$t("special.powerProject.project6"),
          num: "",
        },
        {
          number: this.$t("common.num.seven"),
          serveItem: this.$t("special.powerProject.project7"),
          num: "",
        },
        {
          number: this.$t("common.num.eight"),
          serveItem: this.$t("special.powerProject.project8"),
          num: "",
        },
        {
          number: this.$t("common.num.nine"),
          serveItem: this.$t("special.powerProject.project9"),
          num: "",
        },
        {
          number: this.$t("common.num.ten"),
          serveItem: this.$t("special.powerProject.project10"),
          num: "",
        },
        {
          number: this.$t("common.num.eleven"),
          serveItem: this.$t("special.powerProject.project11"),
          num: "",
        },
        {
          number: this.$t("common.num.twelve"),
          serveItem: this.$t("special.powerProject.project12"),
          num: "",
        },
      ],

      //展台用水
      water: [
        {
          number: this.$t("common.num.one"),
          serveItem: this.$t("special.bootWaterProj1"),
          num: "",
        },
        {
          number: this.$t("common.num.two"),
          serveItem: this.$t("special.bootWaterProj2"),
          num: "",
        },
        {
          number: this.$t("common.num.three"),
          serveItem: this.$t("special.bootWaterProj3"),
          num: "",
        },
        {
          number: this.$t("common.num.four"),
          serveItem: this.$t("special.bootWaterProj4"),
          num: "",
        },
      ],

      imgVisible: false, // 上传图片预览
      dialogImageUrl: "", // 图片预览地址
      //展台效果图图片上传到此数组
      productImgList: [],

      //展台平面图图片上传到此数组
      planImgArr: [],
      //展台立面图
      elevation: [],
      //展台立面图图片上传到此数组
      flag: "", //审核信息标志位
      addVisiable: false,
      addDragInput: "",
      toggleImg: "",
      currentIndex: "",
      currentCoverIndex: "",
    };
  },
  computed: {
    rules() {
      return {
        exhProName: [
          {
            required: true,
            message: this.$t("special.rules.exhProName"),
            trigger: "blur",
          },
        ],
        comAddress: [
          {
            required: true,
            message: this.$t("special.rules.comAddress"),
            trigger: "blur",
          },
        ],
        linkman: [
          {
            required: true,
            message: this.$t("special.rules.linkman"),
            trigger: "blur",
          },
        ],
        cellphone: [
          {
            required: true,
            message: this.$t("special.rules.cellphone"),
            trigger: "blur",
          },
          { min: 11, max: 15, message: this.$t("special.rules.cellphone2") },
        ],
        email: [
          {
            required: true,
            message: this.$t("special.rules.email"),
            trigger: "blur",
          },
          {
            type: "email",
            message: this.$t("special.rules.email2"),
            trigger: ["blur", "change"],
          },
        ],
      };
    },
    rulesBooth() {
      var validateBootImg = (rule, value, callback) => {
        if (this.productImgList.length < 1) {
          callback(new Error(this.$t("special.tishi1")));
        } else {
          callback();
        }
      };

      var validateColumn15 = (rule, value, callback) => {
        if (this.planImgArr.length < 1) {
          callback(new Error(this.$t("special.tishi2")));
        } else {
          callback();
        }
      };
      var validateColumn16 = (rule, value, callback) => {
        if (this.elevation.length < 1) {
          callback(new Error(this.$t("special.tishi3")));
        } else {
          callback();
        }
      };
      return {
        bootHight: [
          { required: true, message: this.$t("special.rulesBooth.tishi0") },
        ],
        bootImg: [
          { validator: validateBootImg },
          {
            trigger: "change",
            message: this.$t("special.rulesBooth.tishi1"),
            required: true,
          },
        ],
        column15: [
          { validator: validateColumn15 },
          {
            trigger: "change",
            message: this.$t("special.rulesBooth.tishi2"),
            required: true,
          },
        ],
        column16: [
          { validator: validateColumn16 },
          {
            trigger: "change",
            message: this.$t("special.rulesBooth.tishi3"),
            required: true,
          },
        ],
      };
    },
  },
  created() {
    if (!this.$route.query.userId) {
      this.$router.go(-1); //返回上一层
    }

    this.getSpecalApply();
  },
  methods: {
    datafile(target, dataSource) {
      let dataSource1 = dataSource;

      for (let index = 0; index < dataSource.length; index++) {
        dataSource1[index].num = target[index];
      }
      return dataSource1;
    },
    getToken() {
      const a = localStorage.getItem("token");
      let token = {};
      token.token = a;
      return token;
    },

    submitForm(formName) {
      // console.log("提交的数据", this.booth);
      //拿到单面口类型

      //拿到展台的id 和名称
      console.log("表格的ref", formName);
      let arr = this.boothVO1;
      let obj = {};
      obj.id = arr[0].id;
      obj.column14 = arr[0].column14;
      this.boothVO = [];
      this.boothVO.push(obj);

      this.sizeForm.boothVO = this.boothVO; //赋值提交的参数
      if (this.hzBoothInfo.bootHight) {
        this.hzBoothInfo.bootHight = parseInt(this.hzBoothInfo.bootHight);
      }
      this.hzBoothInfo.bootLayer = parseInt(this.hzBoothInfo.bootLayer);
      this.hzBoothInfo.bootPowerElectro = this.formatNumbe(this.boothPower); //展台动力用电
      this.hzBoothInfo.bootTemporaryElectro = this.formatNumbe(this.booth); //展台照明用电
      this.hzBoothInfo.remarks = this.formatNumbe(this.water); //展台用水

      //合并对象到大数组sizeForm中
      this.sizeForm.hzBoothInfo = this.hzBoothInfo;
      this.sizeForm.hzExhibitProducer = this.hzExhibitProducer;
      //展台效果图片
      const producrimg = this.formatImgSrc(this.productImgList);
      this.sizeForm.hzBoothInfo.bootImg = producrimg;
      //展台平面图
      this.sizeForm.hzBoothInfo.column15 = this.formatImgSrc(this.planImgArr);
      //展台立面图
      this.sizeForm.hzBoothInfo.column16 = this.formatImgSrc(this.elevation);
      // console.log('表单提交的数据为：',this.sizeForm)
      this.submitVerify(); //校验展台信息表单
      this.submitVerify1();
      this.saveSpecalApply(); //执行提交操作
    },
    submitVerify1() {
      this.$refs.hzExhibitProducer.validate((valid) => {
        if (valid) {
        } else {
          this.$message.error("请填写搭建商信息的必填项");
          return false;
        }
      });
    },
    submitVerify() {
      this.$refs.boothInformation.validate((valid) => {
        if (valid) {
        } else {
          this.$message.error("请填写展台信息的必填项");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    async getSpecalApply() {
      let { data } = await getSpecalApply();
      // console.log('请求特装申请接口的数据', data);

      this.exhibitorsMsg = data.data.hzExhibitorVO; //搭建商信息

      console.log(data.data.hzExhibitProducer, "111");
      if (data.data.hzExhibitProducer != "") {
        // console.log(data.data.hzExhibitProducer, '2222');
        this.hzExhibitProducer = data.data.hzExhibitProducer;
      }
      if (data.data.hzBoothInfo != "") {
        console.log("执行赋值");
        this.hzBoothInfo = data.data.hzBoothInfo;
        this.hzBoothInfo.bootLayer = this.hzBoothInfo.bootLayer.toString();
        // 拿到展台动力用电 的数据
        let bootPowerElectro = this.hzBoothInfo.bootPowerElectro;
        let bootPowerArr = this.formatArr(bootPowerElectro);
        // console.log(bootPowerArr)

        this.boothPower = this.datafile(bootPowerArr, this.boothPower);

        //拿到展台照明用电
        let boothPower = this.hzBoothInfo.bootTemporaryElectro;
        let bootTemporArr = this.formatArr(boothPower);
        this.booth = this.datafile(bootTemporArr, this.booth);
        //拿到展台用水
        let remarks = this.hzBoothInfo.remarks;
        let rematksArr = this.formatArr(remarks);
        this.water = this.datafile(rematksArr, this.water);

        //拿到图片地址需要做处理  展台效果图
        let pictureString = this.hzBoothInfo.bootImg;
        this.pictlist = pictureString.split(",");
        this.pictlist.pop();
        this.pictlist.map((item) => {
          if (item != "") {
            this.productImgList.push({
              name: "ces",
              url: this.baseUrl + item,
            });
          }
        });
        // console.log(this.productImgList)

        //展台平面图
        let planPict = this.hzBoothInfo.column15;
        this.planlist = planPict.split(",");
        this.planlist.pop();
        this.planlist.map((item) => {
          if (item != "") {
            this.planImgArr.push({
              name: "ces",
              url: this.baseUrl + item,
            });
          }
        });
        //展台立面
        let elevationString = this.hzBoothInfo.column16;
        this.elevatinoList = elevationString.split(",");
        this.elevatinoList.pop();
        this.elevatinoList.map((item) => {
          if (item != "") {
            this.elevation.push({
              name: "ces",
              url: this.baseUrl + item,
            });
          }
        });

        this.hzBoothInfo = data.data.hzBoothInfo; //展台信息
      }

      // console.log("-----------",this.hzBoothInfo);

      // if(this.hzBoothInfo!=null){
      //       this.hzBoothInfo.bootLayer=this.hzBoothInfo.bootLayer.toString();
      // }

      this.boothVO1 = data.data.boothVO;
      this.cause = data.data.cause;
      this.flag = parseInt(data.data.auditFlag);
      // console.log("输出展台信息",this.boothVO1);
    },

    async saveSpecalApply() {
      let { data } = await saveSpecalApply(this.sizeForm);
      if (data.code == 200) {
        // console.log("提交成功")
        this.$message.success("提交成功");
        this.$router.go(0);
      }
    },
    //处理图片路径
    formatImgArr(imgsrc) {
      let content1 = imgsrc;
      let shuzuArr1 = [];
      shuzuArr1 = content1.split(",");
      shuzuArr1.pop(); //删除最后一个多余的空数组
      for (let i = 0; i < shuzuArr1.length; i++) {
        shuzuArr1[i] = this.baseUrl + shuzuArr1[i];
      }
      return shuzuArr1;
    },

    //  处理字符串转为数组的形式
    formatArr(content) {
      let content1 = content;
      let shuzuArr = [];
      shuzuArr = content1.split(",");
      return shuzuArr;
    },

    //处理展台数据
    formatNumbe(fordata) {
      let arr = [];
      for (let index = 0; index < fordata.length; index++) {
        if (fordata[index].num == "") {
          fordata[index].num = 0;
          arr.push(fordata[index].num);
        } else {
          arr.push(fordata[index].num);
        }
      }
      return arr.toString();
    },
    //
    format111(str) {
      let index = str.indexOf("/hz/");
      str = str.substring(index, str.length);
      return str;
    },
    //处理图片上传路径
    formatImgSrc(arr) {
      this.arr = arr;
      let imgArr = "";

      for (let index = 0; index < arr.length; index++) {
        imgArr += this.format111(arr[index].url) + ",";
      }

      return imgArr;
    },

    // 图片预览
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.imgVisible = true;
    },

    //-----------展台效果图的相关钩子----------------
    // 展台效果图片上传成功函数
    handSuccessExImg(file) {
      if (file.code == 200) {
        const { name, url } = file.data;

        if (this.currentIndex !== "") {
          // 修改当前选择的文件
          const currentChangeImg = this.productImgList.filter(
            (it, index) => index === this.currentIndex
          );
          currentChangeImg[0].url = this.baseUrl + url;
        } else {
          // 新增的图片文件
          this.productImgList.push({
            name: name,
            url: this.baseUrl + url,
          });
        }
      }
      this.currentIndex = "";
    },
    changeCoverback(index) {
      this.currentCoverIndex = index;
    },
    //展台效果图删除的函数
    changeImgback(index) {
      this.currentIndex = index;
    },
    //展台效果删除效果
    delImg1(currentdelIndex) {
      this.productImgList.splice(currentdelIndex, 1);
    },
    //展台平面图
    delImg2(currentdelIndex) {
      this.planImgArr.splice(currentdelIndex, 1);
    },
    //展台立面图
    delImg3(currentdelIndex) {
      this.elevation.splice(currentdelIndex, 1);
    },

    //文件上传失败时的钩子
    planError(file) {
      console.log(file);
    },

    //-----------展台平面图的相关钩子----------------
    //点击图片上传之前的钩子
    beforeUpload(file) {
      let filehz = file.name.substring(file.name.lastIndexOf(".") + 1); //获取文件后缀
      if (filehz !== "jpg" && filehz !== "png" && filehz !== "gif") {
        this.$message({
          message: this.$t("product.rules.tishi7"),
          type: "warning",
        });
        return false;
      }
      const limitSize = file.size / 1024 / 1024 < 2;
      if (!limitSize) {
        this.$message({
          message: this.$t("dialog.message7"),
          type: "warning",
        });
        return false;
      }
    },

    //文件上传成功的钩子
    handSuccessPlanImg(file) {
      if (file.code == 200) {
        const { name, url } = file.data;

        if (this.currentIndex !== "") {
          // 修改当前选择的文件
          const currentChangeImg = this.planImgArr.filter(
            (it, index) => index === this.currentIndex
          );
          currentChangeImg[0].url = this.baseUrl + url;
        } else {
          // 新增的图片文件
          this.planImgArr.push({
            name: name,
            url: this.baseUrl + url,
          });
        }
      }
      this.currentIndex = "";
    },
    //展台图片移除的函数
    handleRemove() {},
    //---------上传展台立面图的钩子函数------------------
    handSuccessfacadeImg(file) {
      if (file.code == 200) {
        const { name, url } = file.data;

        if (this.currentIndex !== "") {
          // 修改当前选择的文件
          const currentChangeImg = this.elevation.filter(
            (it, index) => index === this.currentIndex
          );
          currentChangeImg[0].url = this.baseUrl + url;
        } else {
          // 新增的图片文件
          this.elevation.push({
            name: name,
            url: this.baseUrl + url,
          });
        }
      }
      this.currentIndex = "";
    },
  },
};
</script>

<style scoped lang="scss">
.apply {
  // padding: 17px 26px;
  box-sizing: border-box;
  background: #f0f2f5;
  .box-card {
    width: 100%;
    border-radius: 2px;
    background: #ffffff;
    .head {
      padding: 17px 0px;
      border-bottom: 1px solid #e8e8e8;
      .applyTitle {
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 600;
        color: #333333;
        line-height: 24px;
        margin-left: 26px;
      }
      .applyEnd {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #666666;
        line-height: 17px;
        margin-left: 17px;
      }
    }
    .serveMessage {
      margin: 0px 26px;
      padding-top: 35px;
      .exhibitorsMsg {
        p {
          font-size: 18px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
          line-height: 22px;
          padding-bottom: 9px;
          border-bottom: 1px solid #e9e9e9;
        }
        .content {
          // padding: 26px 130px 0px 130px;
          margin: 26px 130px 0px 130px;
          .row {
            display: flex;
            padding-bottom: 26px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            .left {
              width: 512px;
              display: flex;
              align-items: center;
              .name {
                width: 115px;
                text-align: right;
              }
            }
            .right {
              display: flex;
              flex: 1;
              align-items: center;
              .name {
                display: block;
                width: 140px;
                text-align: right;
              }
            }
          }
        }
        //搭建商
        .daJian {
          margin: 25px 138px 0px 86px;
          position: relative;

          .layerNumber {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            .el-radio__label {
              font-size: 12px;
              padding-left: 7px;
            }
          }
          .lighting {
            width: 440px;
            height: 36px;
            background: #006fb8;
            border-radius: 3px 3px 0px 0px;
            display: flex;
            align-items: center;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(255, 255, 255, 0.85);
            .number {
              width: 130px;
              text-align: center;
            }
            .serveItem {
              width: 205px;
            }
            .count {
              width: 109px;
            }
          }
          .box {
            width: 430px;
            height: 36px;
            background-color: rgb(255, 255, 255);
            padding: 15px 0px;
            color: black;
            border-bottom: 1px solid #e8e8e8;
          }
          .water {
            position: relative;
            left: -217px;
            top: 20px;
          }
          .input {
            &::after {
              content: "m";
              margin-left: 10px;
            }
          }
          .point {
            &::after {
              content: "个";
              margin-left: 10px;
            }
          }
          .btn {
            margin-top: 20px;
            padding-bottom: 30px;
            .why {
              margin-left: 120px;
              font-size: 12px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #ff190c;
              a {
                margin-left: 10px;
                font-size: 12px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #006fb8;
              }
            }
          }
        }
      }
    }
  }
}

// 传图图片墙样式
.imgBox {
  width: 100%;
  z-index: 9999;
  ul {
    overflow: hidden;
    display: flex;
    margin-bottom: 20px;
    flex-wrap: wrap;
    list-style: none;
    li {
      width: 225px;
      height: 173px;
      margin-right: 20px;
    }
  }
  .upload-logo {
    text-align: center;
    width: 225px;
    height: 173px;
    position: relative;
    display: flex;
    flex-direction: column;
    justify-content: center;
    float: left;
    img {
      position: absolute;
      right: 0;
      top: 0;
    }
  }
}
.hide {
  display: none;
}
</style>
<style scoped>
/* 下拉框样式修改 */
.el-select >>> .el-input__inner {
  height: 28px !important;
}
.el-select >>> .el-input__icon {
  line-height: 28px !important;
}
.row >>> .el-input__inner {
  width: 260px !important;
  height: 28px !important;
}
/* 搭建商信息 */
.el-form-item >>> .el-input__inner {
  width: 260px;
  height: 28px;
}
.el-form-item >>> .el-form-item__label {
  padding: 0px;
}
/* .el-form-item >>> .el-form-item__error {
  top: 85% !important; 
} */
.count >>> .el-input__inner {
  width: 100px;
  height: 28px;
}

.count >>> .el-input {
  width: 100px;
  height: 28px;
}

.upload-demo >>> .el-upload-dragger {
  width: 225px;
  height: 173px;
  background: #f1f1f1;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 0px;
}
.upload-demo >>> .el-upload__text {
  width: fit-content;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #666666;
  width: 120px;
  height: 28px;
  background: #ffffff;
  border-radius: 2px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  line-height: 27px;
}
.el-button--primary {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #ffffff;
  width: 76px;
  height: 28px;
  line-height: 0px;
  background-color: #006fb8;
  text-align: center;
}
.upload-demo >>> .el-upload-list__item {
  width: 225px;
  height: 173px;
  border-radius: 0px;
}
.zhanTai >>> .el-form-item__label {
  width: 240px !important;
}
.zhanTai {
  width: 800px;
  margin-left: -25px;
}
.imgBox >>> .el-upload--picture-card {
  height: 173px !important;
}
</style>
